import { atom } from "recoil";

const accountNumber = atom({ key: "accountNumber", default: "" });
export { accountNumber };
